import { useTranslation } from 'react-i18next';
import { AlloyButton, InfoIcon } from 'cat-ecommerce-alloy';
import { useSelector } from 'react-redux';
import styles from './styles.module.scss';
import cx from 'classnames';
import PropTypes from 'prop-types';
import CoreDepositPopup from '@app/components/common/CoreDepositPopup';

const CoreDeposit = ({ productId = '', showSmallVariant = false }) => {
  const { t } = useTranslation();

  const coreDepositValue = useSelector(
    s => s.products.priceAndAvailability?.[productId]?.coreCharges
  );
  const currency = useSelector(s => s.dealerCustomer?.currency);
  const formattedZeroPrice = useSelector(
    s => s.dealerCustomer?.formattedZeroPrice
  );
  const showPopup =
    !!coreDepositValue && coreDepositValue !== formattedZeroPrice;

  const initiator = (
    <AlloyButton
      data-testid="information_button"
      buttonType="link"
      className="pb-0 pt-1 ps-0"
    >
      <InfoIcon
        className={'me-1 u-fill-icon--MediumGray'}
        style={{ fill: '#565656' }}
        width={showSmallVariant ? 16 : 27}
        height={showSmallVariant ? 16 : 27}
      />
      <span
        className={cx(
          styles[
            showSmallVariant
              ? 'core-deposit-label--small'
              : 'core-deposit-label--large'
          ]
        )}
      >{`${t('CAT_CORE_DEPOSIT_LABEL')}:  `}</span>
    </AlloyButton>
  );

  const getCoreDepositComponent = (
    <>
      <div className="d-flex flex-row align-items-center">
        <CoreDepositPopup initiator={initiator} />
      </div>
      <span
        className={cx(
          {
            'text-xs': showSmallVariant,
            'text-md': !showSmallVariant
          },
          'color-dark-gray'
        )}
      >{`${coreDepositValue} ${currency}`}</span>
    </>
  );
  return showPopup ? getCoreDepositComponent : null;
};

export default CoreDeposit;

CoreDeposit.propTypes = {
  productId: PropTypes.string,
  variant: PropTypes.string
};
